/* eslint-disable class-methods-use-this */
import Popup from './popup';

export default class AddTrackPopup extends Popup {
  createComponent() {
    return document.createElement(`au-${this.type}`);
  }

  setAttributes(addTrackPopup) {
    if (this._detail?.name)
      addTrackPopup.setAttribute('name', this._detail.name);
    if (this._detail?.semanticName)
      addTrackPopup.setAttribute('semantic-name', this._detail.semanticName);
  }
}
